import CategoryIndicator from './CategoryIndicator';
export default CategoryIndicator;
